<template>
    <div class="row mx-0">
        <div class="col-6 px-0">
            <b-form-checkbox
                v-model="form.can_access_app"
                name="check-button"
                switch
                :title="switchTitle"
                :disabled="switchDisabled"
                @change="saveSwitchState"
            />
        </div>
        <div class="col-6 px-0 text-left text-secondary">
            <b-link
                v-if="form.can_access_app"
                :key="'link' + key"
                :href="/log-as-client/ + contact.uuid"
                target="_blank"
                :title="switchTitle"
            >
                <i class="fas fa-fw fa-sign-in"></i>
            </b-link>
            <span v-else :key="'info' + key" :title="switchTitle">
                <i class="far fa-fw fa-info-circle"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppAccessSwitch',

    props: {
        contact: null,
    },

    data() {
        return {
            form: {
                can_access_app: false,
            },
            key: '',
        }
    },

    computed: {
        switchTitle() {
            if (this.switchDisabled) {
                return "L'accès à l'application ne peut être activé car le contact n'a pas d'adresse email renseignée"
            }
            return this.form.can_access_app
                ? "Accéder au compte de ce contact sur l'application client"
                : "Ce contact ne peut accéder à l'application client"
        },
        switchDisabled() {
            return this.contact.email === null
        },
    },

    created() {
        this.form.can_access_app = this.contact.can_access_app === 1
        this.updateKey()
    },

    methods: {
        async saveSwitchState() {
            console.log('saving: ', this.form)
            try {
                await axios.put(
                    `/clientContacts/${this.contact.id}/physicalPersons/${this.contact.physical_person_id}`,
                    this.form
                )
                this.updateKey()
            } catch (error) {
                console.log(error)
            }
        },

        updateKey() {
            this.key = Date.now()
        },
    },
}
</script>

<style scoped></style>
